var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.spinner,"spinner-variant":"primary","rounded":"sm"}},[_c('comprasForm',{attrs:{"compra":_vm.compraData,"compraSubmit":"Crear OC"},on:{"processCompra":_vm.agregarCompras}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }